import React from 'react';
import { Icon } from '@instinet-analytics/semantic-ui-components';

export const performanceVsTooltip = {
    title: 'Performance versus',
    body: "refers to the price movement, calculated by comparing % change in price from previous night's close, of a symbol versus an Index.",
};
export const indexTooltip = {
    body: (
        <span>
            The % change in the Index price since the orders&apos;s arrival
            time. The Index can be changed in the chart configuration{' '}
            <Icon name="cog" />.
        </span>
    ),
};
